import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import doctorImg from "../../../assets/doctors.png";
import { Stack } from "@mui/material";

const useStyles = makeStyles(() => ({
  img: {
    // width: "100%",
    // height: "auto",
    height: "100px",
    objectFit: "cover",
    objectPosition: "center",
    // backgroundColor: "#000",
  },
  root: {
    cursor: "pointer",
    padding: "8px",
    borderRadius: "16px !important",
    width: "100%"
  },
  textContent: {
    padding: "0 8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));
const Medium = (props) => {
  const classes = useStyles();
  const {
    title = "Undefined",
    text = "Undefined",
    img,
    click = () => {},
  } = props;
  return (
    <Paper {...props} className={classes.root} onClick={click}>
      <Stack spacing={1} alignItems="center">
        <img
          className={classes.img}
          src={img}
          alt={title}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = doctorImg;
          }}
        />
        <Typography
          variant="body1"
          fontWeight="bold"
          overflow="hidden"
          textOverflow="ellipsis"
          textAlign="center"
        >
          {title}
        </Typography>
        <Typography variant="body2" textAlign="center">
            {text}
          </Typography>
      </Stack>
      {/* <Grid container direction={"column"} display="flex" alignItems="center" justifyContent="center">
        <Grid item container justifyContent={"center"} alignItems="center">
          <img
            className={classes.img}
            src={img}
            alt={title}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = doctorImg;
            }}
          />
        </Grid>
        <Grid item>
          <Typography
            variant="body1"
            noWrap
            overflow="hidden"
            textOverflow="ellipsis"
            width="70%"
            textAlign="center"
          >
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" textAlign="center">
            {text}
          </Typography>
        </Grid>
      </Grid> */}
    </Paper>
  );
};

export default Medium;
